import React, {Component} from 'react';
import {Spinner, Tooltip} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {addUsersInfo} from "../redux/general/actions";
import {createUUID} from "../helpers/Utils";
import {store} from "../AppRenderer";
import Api from "../services/Api";

class UserInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isOpen: false,
      info: store.getState().general.usersInfo[props.id],
    };
    this.tooltipId = `ID-${createUUID()}`;
  }

  async componentDidUpdate(prevProps, prevState) {
    if (!prevState.isOpen && this.state.isOpen && !this.state.info) {
      await this.getUserInfo();
    }
  }

  getUserInfo = async () => {
    this.setState({loading: true});
    const {type, id} = this.props;
    try {
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/users/info',
        null,
        {
          params: {
            type,
            id,
          }
        }
      );
      this.setState({info: data});
      store.dispatch(addUsersInfo({id, type, ...data}));
    } catch (e) {
    } finally {
      this.setState({loading: false});
    }
  };

  toggle = () => {
    this.setState(({isOpen}) => ({
      isOpen: !isOpen,
    }));
  };

  render() {
    const {info, loading} = this.state;
    const {t, type, id, label, textColor, onClick} = this.props;
    return (
      <div>
        <div
          id={this.tooltipId}
          style={{fontWeight: 500}}
          onClick={onClick ? onClick : () => {}}
          className='d-flex flex-row align-items-center text-info cursor-pointer'>
          {type !== "SYSTEM" && <i className={`simple-icon-user ${textColor}`}/>}
          <span className={`mx-1 ${textColor}`}>{label}</span>
        </div>
        {type !== "SYSTEM" &&
          <Tooltip
            placement="bottom"
            target={this.tooltipId}
            isOpen={this.state.isOpen}
            popperClassName="user-info-tooltip"
            innerClassName="user-info-tooltip"
            toggle={this.toggle}
            delay={200}>
            {loading ?
              <Spinner color="primary" /> :
              <div>
                {!!info && !!info.username &&
                  <div className="d-flex flex-row align-items-center">
                    <span className="text-dark">{t("Username")}:</span>
                    <span className="text-info mx-1">{info.username}</span>
                  </div>
                }
                {!!info && type !== "ADMIN" &&
                  <div className="d-flex flex-row align-items-center">
                    <span className="text-dark">{t("User Id")}:</span>
                    <span className="text-info mx-1">{id}</span>
                  </div>
                }
                {!!info && !!info.firstName &&
                  <div className="d-flex flex-row align-items-center mt-2">
                    <span className="text-dark">{t("First Name")}:</span>
                    <span className="text-info mx-1">{info.firstName}</span>
                  </div>
                }
                {!!info && !!info.lastName &&
                  <div className="d-flex flex-row align-items-center mt-2">
                    <span className="text-dark">{t("Last Name")}:</span>
                    <span className="text-info mx-1">{info.lastName}</span>
                  </div>
                }
                {!!info && !!info.email &&
                  <div className="d-flex flex-row align-items-center mt-2">
                    <span className="text-dark">{t("Email")}:</span>
                    <span className="text-info mx-1">{info.email}</span>
                  </div>
                }
                {!!info && !!info.phoneNumber &&
                  <div className="d-flex flex-row align-items-center mt-2">
                    <span className="text-dark">{t("Mobile Number")}:</span>
                    <span className="text-info mx-1">{info.phoneNumber}</span>
                  </div>
                }
              </div>
            }
          </Tooltip>
        }
      </div>
    );
  }
}

export default withTranslation()(UserInfo);